import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const links = [
  { id: "about", label: "About" },
  { id: "work", label: "Work" },
  { id: "career", label: "Career" },
  { id: "testimonials", label: "Testimonials" },
  { id: "contact", label: "Contact" },
];

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    // Close the mobile menu first, then scroll once the layout has settled.
    setOpen(false);
    setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 220);
  };

  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-[#F4F1EA]/85 border-b border-black/10" : "bg-transparent"
      }`}
      data-testid="site-nav"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-14 py-5 flex items-center justify-between">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-baseline"
          data-testid="nav-logo"
        >
          <span className="font-display text-2xl">Mia O'Neill</span>
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              className="text-[11px] uppercase tracking-[0.22em] font-semibold link-underline"
              data-testid={`nav-link-${l.id}`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          aria-label="Toggle menu"
          onClick={() => setOpen(!open)}
          className="md:hidden flex flex-col gap-1.5"
          data-testid="nav-mobile-toggle"
        >
          <span className={`block w-7 h-[2px] bg-black transition-transform ${open ? "translate-y-[7px] rotate-45" : ""}`} />
          <span className={`block w-7 h-[2px] bg-black transition-opacity ${open ? "opacity-0" : ""}`} />
          <span className={`block w-7 h-[2px] bg-black transition-transform ${open ? "-translate-y-[7px] -rotate-45" : ""}`} />
        </button>
      </div>

      <motion.div
        initial={false}
        animate={{ height: open ? "auto" : 0, opacity: open ? 1 : 0 }}
        transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
        className="md:hidden overflow-hidden bg-[#F4F1EA] border-t border-black/10"
        style={{ visibility: open ? "visible" : "hidden", pointerEvents: open ? "auto" : "none" }}
        aria-hidden={!open}
        data-testid="nav-mobile-menu"
      >
        <div className="px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              className="text-left text-3xl font-display"
              data-testid={`nav-mobile-link-${l.id}`}
            >
              {l.label}
            </button>
          ))}
        </div>
      </motion.div>
    </motion.header>
  );
};

export default Nav;
